import axios from 'axios'
import qs from 'qs'
const root = '/dev-api'
function $http (type, url, params, status, baseURL = root) {
  console.log({ baseURL })
  return new Promise((resolve, reject) => {
    let postParams = {}
    const instance = axios.create({
      timeout: 30000,
      headers: {
        'Content-Type': 'application/json' // 设置默认请求头为JSON格式
      }
    })
    postParams = params
    let fetchData = {
      method: type,
      url: `${baseURL}${url}`,
      data: qs.stringify(postParams)
    }

    if (type === 'get' || type === 'GET') {
      fetchData = {
        method: type,
        url: `${baseURL}${url}`,
        params: postParams
      }
    } else {
      // 其他请求使用data参数，直接传递JSON对象
      fetchData.data = params
    }
    instance(fetchData).then(response => {
      const res = response.data
      if (res.errno === status) {
        resolve(res)
      } else {
        resolve(res)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export {
  $http
}
